export interface FiltersReducerState {
  time: number;
  networks: string[];
  searchTerm: string;
}

export const FILTER_ACTIONS = {
  UPDATE_NETWORKS: 'update networks',
  UPDATE_TIME: 'update time',
  UPDATE_SEARCH: 'update search',
  UPDATE_ALL_FILTERS: 'update all filters',
  CLEAR: 'clear',
} as const;

type FiltersActionTypes =
  | { type: 'update time'; payload: number }
  | { type: 'update networks'; payload: string[] }
  | { type: 'update search'; payload: string }
  | { type: 'update all filters'; payload: FiltersReducerState }
  | { type: 'clear' };

export enum timeValues {
  ALL_TIME = 0,
  ONE_DAY = 1440,
  SEVEN_DAYS = 10080,
  THIRTY_DAYS = 43200,
  NINETY_DAYS = 129600,
  TWELVE_MONTHS = 525600,
}

export const timeFilters = [
  { label: 'All time', value: timeValues.ALL_TIME },
  { label: 'Last 24 hours', value: timeValues.ONE_DAY },
  { label: 'Last 7 days', value: timeValues.SEVEN_DAYS },
  { label: 'Last 30 days', value: timeValues.THIRTY_DAYS },
  { label: 'Last 90 days', value: timeValues.NINETY_DAYS },
  { label: 'Last 12 months', value: timeValues.TWELVE_MONTHS },
];

export const timeFilterLabels = timeFilters.reduce<Record<number, string>>((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});

export const initialFiltersState = {
  time: 0,
  networks: [],
  searchTerm: '',
};

export function filtersReducer(state: FiltersReducerState, action: FiltersActionTypes) {
  switch (action.type) {
    case FILTER_ACTIONS.UPDATE_NETWORKS:
      return { ...state, networks: action.payload };
    case FILTER_ACTIONS.UPDATE_TIME:
      return { ...state, time: action.payload };
    case FILTER_ACTIONS.UPDATE_SEARCH:
      return { ...state, searchTerm: action.payload };
    case FILTER_ACTIONS.UPDATE_ALL_FILTERS:
      return action.payload;
    case FILTER_ACTIONS.CLEAR:
      return initialFiltersState;
    default:
      return state;
  }
}
